import React, { Fragment, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowLeftIcon } from '../../../assets/images/arrow-left.svg';
import { ReactComponent as DragHandleIcon } from '../../../assets/images/drag-handle.svg';
import Button from '../../../components/Elements/button/button';
import Dropdown from '../../../components/FormElements/dropdown';
import InputElement from '../../../components/FormElements/input';
import DropDown from '../../../components/McDropdown';
import { fontStyleOptions, formComponentTypes } from '../../../constant/optionData';
import FormBuilderContext from '../../../context/FormBuilderContext';
import { ColorPicker } from '../common/color-picker';
import { AdvancedConfig } from './advanced-config';
import { AlignmentConfig } from './alignment-config';
import { ChooserOptionsConfig } from './chooser-option-config';
import { GeneralConfig } from './general-config';
import { HeaderGeneralConfig } from './header-general-config';
import { ImageGeneralConfig } from './image-general-config';
import { MultichoiceGeneralConfig } from './multichoice-general-config';
import { PaymentGeneralConfig } from './payment-general-config';
import { ProductGeneralConfig } from './product-general-config';

import styled from 'styled-components';
import uuid from 'react-uuid';

export const ComponentConfigs = ({
  component,
  setSelectedComponent,
  deleteComponent,
  updateWidget,
  panelId,
  selectedWidget,
  selectComponent,
  panelWidgets,
  signers,
  selectedPage,
}) => {
  const { component_type, row, column, width, height, x, y, font, component_color, columns } = component;
  const { t } = useTranslation();
  const { fonts } = useContext(FormBuilderContext);
  const { name, style, size, color, line_height } = font;
  const [colorPicker, setColorPicker] = useState('');
  const [colorPicker1, setColorPicker1] = useState('');
  const align = [
    { id: 'TOP', name: 'TOP' },
    { id: 'TOP', name: 'CENTER' },
    { id: 'TOP', name: 'BOTTOM' },
  ];

  const updateComponentDetails = comp => {
    updateWidget({
      ...selectedWidget,
      panelId: panelId,
      components: selectedWidget.components.map(c => (c.id === comp.id ? comp : c)),
    });
    selectComponent(comp);
  };

  const addColumn = () => {
    updateComponentDetails({
      ...component,
      columns: [
        ...(component.columns || []),
        {
          id: uuid(),
          size: 100,
          text: '',
          opacity: 1,
          priority: component.columns?.length || 0,
          font: font,
          background_color: component_color,
          padding: { top: 0, right: 0, bottom: 0, left: 0 },
        },
      ],
    });
  };

  const deleteColumn = column => {
    updateComponentDetails({
      ...component,
      columns: component.columns?.filter(c => c.id !== column.id),
    });
  };

  return (
    <ConfigWrapper className="flex-column flex-1 overflow-hidden">
      <div className="flex items-center">
        <div className="flex items-center pxy-1 mr-2 cursor" onClick={() => setSelectedComponent(null, false)}>
          <ArrowLeftIcon height={16} width={16} />
        </div>
        <label className="flex-1 medium-text font-16">{t('COMPONENT_DETAILS')}</label>
        {/* <div className="pxy-1 radius-2 flex items-center justify-center cursor delete-widget">
          <DeleteIcon
            height={16}
            width={16}
            onClick={e => {
              e.stopPropagation();
              deleteComponent(component);
            }}
          />
        </div> */}
      </div>
      <div className="flex-column overflow-scroll px-1" style={{ height: 'calc(100vh - 140px)' }}>
        {/* <div className="flex-column mt-8">
          <label className=" flex-1 medium-text font-16">WIDGET</label>
          <label className="mt-2 cursor" onClick={() => setSelectedComponent(null, false)}>
            {selectedWidget.name}
          </label>
        </div> */}
        <div className="flex-column mt-6">
          <label className=" flex-1 medium-text font-16">{t('OPTIONS_UC')}</label>
          <InputElement
            name="Name"
            onChange={value => updateComponentDetails({ ...component, name: value })}
            value={component.name}
            label="Enter"
            className="w-full mt-6"
            font={{ size: 12 }}
            showRequiredError={true}
          />
          <div className="flex items-center">
            <div className="flex-1 mr-2">
              <Dropdown
                className="mt-6"
                name="Component type"
                placeholder="Select type"
                options={formComponentTypes}
                font={{ size: 12 }}
                selectedValue={formComponentTypes.find(c => c.value === component_type)}
                onChange={option => updateComponentDetails({ ...component, component_type: option.value })}
              />
            </div>
            {component_type !== 'IMAGE' && (
              <div className="flex-1 ml-2">
                <ColorPicker
                  className="flex items-centers mt-6"
                  topLabel={'Color'}
                  settingKey={'color'}
                  selectedColor={component.component_color}
                  onChangeColor={(settingKey, color) => setSelectedComponent({ ...component, component_color: color })}
                  colorPicker={colorPicker || '#000000'}
                  setColorPicker={setColorPicker}
                />
              </div>
            )}
          </div>
          {/* <div className="mt-6 flex col-gap-4">
            <InputElement
              name="Row"
              onChange={value => updateComponentDetails({ ...component, row: value })}
              value={row}
              label="Row"
              className="w-full"
              font={{ size: 12 }}
            />
            <InputElement
              name="Column"
              onChange={value => updateComponentDetails({ ...component, column: value })}
              value={column}
              label="Column"
              className="w-full"
              font={{ size: 12 }}
            />
          </div> */}
          <div className="mt-6 flex items-center col-gap-4">
            <InputElement
              name="Width"
              onChange={value => updateComponentDetails({ ...component, width: value ? parseFloat(value) : value })}
              value={width}
              label="Width"
              className="w-full"
              font={{ size: 12 }}
            />
            <InputElement
              name="Height"
              onChange={value => updateComponentDetails({ ...component, height: value ? parseFloat(value) : value })}
              value={height}
              label="Height"
              className="w-full"
              font={{ size: 12 }}
            />
          </div>
          <div className="mt-6 flex col-gap-4">
            <InputElement
              name="X"
              onChange={value => updateComponentDetails({ ...component, x: value ? parseFloat(value) : value })}
              value={x}
              label="X"
              className="w-full"
              font={{ size: 12 }}
            />
            <InputElement
              name="Y"
              onChange={value => updateComponentDetails({ ...component, y: value ? parseFloat(value) : value })}
              value={y}
              label="Y"
              className="w-full"
              font={{ size: 12 }}
            />
          </div>
        </div>
        <InputElement
          name="Lexicon"
          onChange={value => setSelectedComponent({ ...component, lexicon: value })}
          value={component.lexicon}
          label="Enter"
          className="w-full mt-6 pb-6"
          font={{ size: 12 }}
        />
        {component_type && (
          <Fragment>
            <div className="hr-line" />
            {component_type === 'HEADER' ? (
              <HeaderGeneralConfig component={component} setSelectedComponent={updateComponentDetails} />
            ) : component_type === 'PRODUCT' ? (
              <ProductGeneralConfig component={component} setSelectedComponent={updateComponentDetails} />
            ) : component_type === 'PAYMENT' ? (
              <PaymentGeneralConfig component={component} setSelectedComponent={updateComponentDetails} />
            ) : component_type === 'IMAGE' ? (
              <ImageGeneralConfig component={component} setSelectedComponent={updateComponentDetails} />
            ) : component_type === 'MULTICHOICE' ? (
              <MultichoiceGeneralConfig component={component} setSelectedComponent={updateComponentDetails} />
            ) : (
              <div className="flex-column">
                <div className="pb-8 border-bottom mt-8 flex-column">
                  <label className="medium-text">{t('FONT_UC')}</label>
                  <div className="flex items-center mt-6">
                    <div className="flex items-center flex-1 mr-2">
                      <div className="flex-column flex-1">
                        <label className="flex regular-text flex-1 mb-1 regular-text lighter-text">
                          {t('DEFAULT_FONT')}
                        </label>
                        <DropDown
                          className="flex-1"
                          options={fonts}
                          selected={fonts.find(f => f.name === name)}
                          placeholder="Font"
                          setSelected={option =>
                            updateComponentDetails({ ...component, font: { ...component.font, name: option.name } })
                          }
                        />
                      </div>
                    </div>
                    <div className="flex items-center flex-1 ml-2">
                      <div className="flex-column flex-1">
                        <label className="flex regular-text flex-1 mb-1 regular-text lighter-text">
                          {t('FONT_STYLE')}
                        </label>
                        <DropDown
                          className="flex-1"
                          options={fontStyleOptions}
                          selected={fontStyleOptions.find(fs => fs.value === style)}
                          placeholder="Style"
                          setSelected={option =>
                            updateComponentDetails({ ...component, font: { ...component.font, style: option.value } })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center mt-4">
                    <div className="flex-column flex-1 mr-2">
                      <label className="flex mb-1 regular-text lighter-text">Size</label>
                      <input
                        className="input general-settings-input w-full"
                        placeholder="Size"
                        type="number"
                        value={size}
                        onChange={({ target: { value } }) =>
                          updateComponentDetails({ ...component, font: { ...component.font, size: value } })
                        }
                      />
                    </div>
                    <ColorPicker
                      className="flex items-centers flex-1 mr-2"
                      topLabel={'Color'}
                      settingKey={'default_font_color'}
                      selectedColor={color || '#000000'}
                      onChangeColor={(settingKey, color) =>
                        updateComponentDetails({ ...component, font: { ...component.font, color: color } })
                      }
                      colorPicker={colorPicker || '#000000'}
                      setColorPicker={setColorPicker}
                    />
                    <div className="flex-column flex-1">
                      <div className="flex-column">
                        <label className="flex mb-1 regular-text lighter-text">Line height</label>
                        <input
                          className="input general-settings-input w-full"
                          placeholder="Line height"
                          type="number"
                          value={line_height}
                          onChange={({ target: { value } }) =>
                            updateComponentDetails({ ...component, font: { ...component.font, line_height: value } })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  {component_type !== 'IMAGE' && (
                    <AlignmentConfig
                      alignment={component.alignment}
                      setAlignment={a => updateComponentDetails({ ...component, alignment: a })}
                    />
                  )}
                  <div className="hr-line my-6" />
                  <label className=" flex-1 medium-text font-16">BORDER</label>
                  <div className="mt-4 flex items-center col-gap-4">
                    <InputElement
                      name="Top"
                      onChange={value =>
                        updateComponentDetails({ ...component, border: { ...component.border, top: value } })
                      }
                      value={component.border?.top}
                      label="Top"
                      className="w-full"
                      font={{ size: 12 }}
                    />
                    <InputElement
                      name="Right"
                      onChange={value =>
                        updateComponentDetails({ ...component, border: { ...component.border, right: value } })
                      }
                      value={component.border?.right}
                      label="Right"
                      className="w-full"
                      font={{ size: 12 }}
                    />
                  </div>
                  <div className="mt-4 flex items-center col-gap-4">
                    <InputElement
                      name="Bottom"
                      onChange={value =>
                        updateComponentDetails({ ...component, border: { ...component.border, bottom: value } })
                      }
                      value={component.border?.bottom}
                      label="Bottom"
                      className="w-full"
                      font={{ size: 12 }}
                    />
                    <InputElement
                      name="Left"
                      onChange={value =>
                        updateComponentDetails({ ...component, border: { ...component.border, left: value } })
                      }
                      value={component.border?.left}
                      label="Left"
                      className="w-full"
                      font={{ size: 12 }}
                    />
                  </div>
                  <div className="hr-line my-6" />
                  <label className=" flex-1 medium-text font-16">BORDER RADIUS</label>
                  <div className="flex items-center">
                    <div className="mt-4 flex items-center flex-1 mr-1">
                      <InputElement
                        onChange={value =>
                          updateComponentDetails({
                            ...component,
                            border_radius: value ? parseFloat(value) : value,
                          })
                        }
                        value={component.border_radius}
                        label="Border Radius"
                        className="w-full mr-1"
                        font={{ size: 12 }}
                      />
                    </div>
                  </div>
                  <div className="hr-line my-6" />
                  {component_type === 'TABLE' && (
                    <>
                      <label className=" flex-1 medium-text font-16">PARENT</label>
                      <Dropdown
                        className="mt-6"
                        name="Parent"
                        placeholder="Select"
                        options={[
                          { id: 'None', label: 'None' },
                          ...panelWidgets
                            .map(p => p.widgets)
                            .flat()
                            .map(w => w.components)
                            .flat()
                            .filter(c => c.component_type === 'TABLE')
                            .map(s => ({ ...s, label: s.name })),
                        ]}
                        font={{ size: 12 }}
                        selectedValue={panelWidgets
                          .map(p => p.widgets)
                          .flat()
                          .map(w => w.components)
                          .flat()
                          .filter(c => c.component_type === 'TABLE')
                          .map(s => ({ ...s, label: s.name }))
                          .find(c => c.id === component?.parent?.id)}
                        onChange={option =>
                          setSelectedComponent({ ...component, parent: option.id === 'None' ? null : option })
                        }
                      />
                    </>
                  )}
                </div>
                {component_type === 'TABLE' && (
                  <div className="flex-column py-4">
                    <label className="medium-text">COLUMNS</label>
                    {columns?.map((c, i) => (
                      <div key={i} className="flex-column flex-1 ml-4 mt-4 border pxy-4">
                        <div className="flex items-center justify-between cursor">
                          <div className="flex items-center">
                            <DragHandleIcon />
                            <label className="medium-text ml-2">Column {i + 1}</label>
                          </div>
                          <div className="flex-column mt-2" style={{ width: '80px' }}>
                            <Button
                              size="small"
                              label="Delete"
                              className="negative"
                              bgColor="red"
                              onClick={() => deleteColumn(c)}
                            />
                          </div>
                        </div>
                        <InputElement
                          name="Text"
                          onChange={value =>
                            updateComponentDetails({
                              ...component,
                              columns: component.columns.map(column =>
                                column.id === c.id ? { ...column, text: value } : column,
                              ),
                            })
                          }
                          value={c.text}
                          label="Enter"
                          className="w-full mt-6"
                          font={{ size: 12 }}
                          showRequiredError={true}
                        />
                        <div className="flex items-center mt-4">
                          <div className="flex-1 mr-2">
                            <InputElement
                              name="Size"
                              onChange={value =>
                                updateComponentDetails({
                                  ...component,
                                  columns: component.columns.map(column =>
                                    column.id === c.id ? { ...column, size: value } : column,
                                  ),
                                })
                              }
                              value={c.size}
                              label="Size"
                              className="w-full"
                              font={{ size: 12 }}
                            />
                          </div>
                          <InputElement
                            name="Opacity"
                            onChange={value =>
                              updateComponentDetails({
                                ...component,
                                columns: component.columns.map(column =>
                                  column.id === c.id ? { ...column, opacity: value } : column,
                                ),
                              })
                            }
                            value={c.opacity}
                            label="Opacity"
                            className="w-full flex-1"
                            font={{ size: 12 }}
                          />
                          <ColorPicker
                            className="flex flex-2 items-centers ml-2"
                            topLabel={'Color'}
                            settingKey={`color ${c.id}`}
                            selectedColor={c.background_color}
                            onChangeColor={(settingKey, color) =>
                              updateComponentDetails({
                                ...component,
                                columns: component.columns.map(column =>
                                  column.id === c.id ? { ...column, background_color: color } : column,
                                ),
                              })
                            }
                            colorPicker={colorPicker1 || '#000000'}
                            setColorPicker={setColorPicker1}
                          />
                        </div>
                        <div className="flex-column">
                          <div className="flex items-center mt-6">
                            <div className="flex-column flex-1 mr-2">
                              <label className="flex mb-1 regular-text lighter-text">Vertical Align</label>
                              <DropDown
                                className="flex-1"
                                options={align}
                                selected={align.find(f => f.name === c.vertical_align)}
                                placeholder="Align"
                                setSelected={option =>
                                  updateComponentDetails({
                                    ...component,
                                    columns: component.columns.map(column =>
                                      column.id === c.id ? { ...column, vertical_align: option.name } : column,
                                    ),
                                  })
                                }
                              />
                            </div>
                            <div className="flex-column flex-1 ml-2"></div>
                          </div>
                        </div>
                        <div className="flex-column">
                          <div className="flex items-center mt-6">
                            <div className="flex-column flex-1 mr-2">
                              <label className="flex mb-1 regular-text lighter-text">{t('DEFAULT_FONT')}</label>
                              <DropDown
                                className="flex-1"
                                options={fonts}
                                selected={fonts.find(f => f.name === c.font?.name)}
                                placeholder="Font"
                                setSelected={option =>
                                  updateComponentDetails({
                                    ...component,
                                    columns: component.columns.map(column =>
                                      column.id === c.id
                                        ? { ...column, font: { ...column.font, name: option.name } }
                                        : column,
                                    ),
                                  })
                                }
                              />
                            </div>
                            <div className="flex-column flex-1 ml-2">
                              <label className="flex mb-1 regular-text lighter-text">{t('FONT_STYLE')}</label>
                              <DropDown
                                className="flex-1"
                                options={fontStyleOptions}
                                selected={fontStyleOptions.find(fs => fs.value === c.font?.style)}
                                placeholder="Style"
                                setSelected={option =>
                                  updateComponentDetails({
                                    ...component,
                                    columns: component.columns.map(column =>
                                      column.id === c.id
                                        ? { ...column, font: { ...column.font, style: option.value } }
                                        : column,
                                    ),
                                  })
                                }
                              />
                            </div>
                          </div>
                          <div className="flex items-center mt-6">
                            <div className="flex-column flex-1 mr-1">
                              <label className="flex mb-1 regular-text lighter-text">Size</label>
                              <input
                                className="input general-settings-input w-full"
                                placeholder="Size"
                                type="number"
                                value={c.font?.size}
                                onChange={({ target: { value } }) =>
                                  updateComponentDetails({
                                    ...component,
                                    columns: component.columns.map(column =>
                                      column.id === c.id
                                        ? { ...column, font: { ...column.font, size: value } }
                                        : column,
                                    ),
                                  })
                                }
                              />
                            </div>
                            <ColorPicker
                              className="flex-column flex-1 mr-1"
                              topLabel={'Color'}
                              settingKey={`column_font_color ${c.id}`}
                              selectedColor={c.font?.color || '#000000'}
                              onChangeColor={(settingKey, color) =>
                                updateComponentDetails({
                                  ...component,
                                  columns: component.columns.map(column =>
                                    column.id === c.id ? { ...column, font: { ...column.font, color: color } } : column,
                                  ),
                                })
                              }
                              colorPicker={colorPicker || '#000000'}
                              setColorPicker={setColorPicker}
                            />
                            <div className="flex-column flex-1">
                              <label className="flex mb-1 regular-text lighter-text">Line height</label>
                              <input
                                className="input general-settings-input w-full"
                                placeholder="Line height"
                                type="number"
                                value={c.font?.line_height}
                                onChange={({ target: { value } }) =>
                                  updateComponentDetails({
                                    ...component,
                                    columns: component.columns.map(column =>
                                      column.id === c.id
                                        ? { ...column, font: { ...column.font, line_height: value } }
                                        : column,
                                    ),
                                  })
                                }
                              />
                            </div>
                          </div>
                          <AlignmentConfig
                            alignment={c.alignment}
                            setAlignment={a =>
                              updateComponentDetails({
                                ...component,
                                columns: component.columns.map(column =>
                                  column.id === c.id ? { ...column, alignment: a } : column,
                                ),
                              })
                            }
                          />
                          <div className="hr-line my-6" />
                          <label className=" flex-1 medium-text font-16">PADDING</label>
                          <div className="flex items-center col-gap-2">
                            <div className="mt-4 flex items-center col-gap-2">
                              <InputElement
                                name="Top"
                                onChange={value =>
                                  updateComponentDetails({
                                    ...component,
                                    columns: component.columns.map(column =>
                                      column.id === c.id
                                        ? {
                                            ...column,
                                            padding: { ...column.padding, top: value ? parseFloat(value) : value },
                                          }
                                        : column,
                                    ),
                                  })
                                }
                                value={c.padding?.top}
                                label="Top"
                                className="w-full"
                                font={{ size: 12 }}
                              />
                              <InputElement
                                name="Right"
                                onChange={value =>
                                  updateComponentDetails({
                                    ...component,
                                    columns: component.columns.map(column =>
                                      column.id === c.id
                                        ? {
                                            ...column,
                                            padding: { ...column.padding, right: value ? parseFloat(value) : value },
                                          }
                                        : column,
                                    ),
                                  })
                                }
                                value={c.padding?.right}
                                label="Right"
                                className="w-full"
                                font={{ size: 12 }}
                              />
                            </div>
                            <div className="mt-4 flex items-center col-gap-2">
                              <InputElement
                                name="Bottom"
                                onChange={value =>
                                  updateComponentDetails({
                                    ...component,
                                    columns: component.columns.map(column =>
                                      column.id === c.id
                                        ? {
                                            ...column,
                                            padding: { ...column.padding, bottom: value ? parseFloat(value) : value },
                                          }
                                        : column,
                                    ),
                                  })
                                }
                                value={c.padding?.bottom}
                                label="Bottom"
                                className="w-full"
                                font={{ size: 12 }}
                              />
                              <InputElement
                                name="Left"
                                onChange={value =>
                                  updateComponentDetails({
                                    ...component,
                                    columns: component.columns.map(column =>
                                      column.id === c.id
                                        ? {
                                            ...column,
                                            padding: { ...column.padding, left: value ? parseFloat(value) : value },
                                          }
                                        : column,
                                    ),
                                  })
                                }
                                value={c.padding?.left}
                                label="Left"
                                className="w-full"
                                font={{ size: 12 }}
                              />
                            </div>
                          </div>
                          <div className="hr-line my-6" />
                          <label className=" flex-1 medium-text font-16">BORDER</label>
                          <div className="mt-4 flex items-center col-gap-4">
                            <InputElement
                              name="Top"
                              onChange={value =>
                                updateComponentDetails({
                                  ...component,
                                  columns: component.columns.map(column =>
                                    column.id === c.id
                                      ? { ...column, border: { ...column.border, top: value } }
                                      : column,
                                  ),
                                })
                              }
                              value={c.border?.top}
                              label="Top"
                              className="w-full"
                              font={{ size: 12 }}
                            />
                            <InputElement
                              name="Right"
                              onChange={value =>
                                updateComponentDetails({
                                  ...component,
                                  columns: component.columns.map(column =>
                                    column.id === c.id
                                      ? { ...column, border: { ...column.border, right: value } }
                                      : column,
                                  ),
                                })
                              }
                              value={c.border?.right}
                              label="Right"
                              className="w-full"
                              font={{ size: 12 }}
                            />
                          </div>
                          <div className="mt-4 flex items-center col-gap-4">
                            <InputElement
                              name="Bottom"
                              onChange={value =>
                                updateComponentDetails({
                                  ...component,
                                  columns: component.columns.map(column =>
                                    column.id === c.id
                                      ? { ...column, border: { ...column.border, bottom: value } }
                                      : column,
                                  ),
                                })
                              }
                              value={c.border?.bottom}
                              label="Bottom"
                              className="w-full"
                              font={{ size: 12 }}
                            />
                            <InputElement
                              name="Left"
                              onChange={value =>
                                updateComponentDetails({
                                  ...component,
                                  columns: component.columns.map(column =>
                                    column.id === c.id
                                      ? { ...column, border: { ...column.border, left: value } }
                                      : column,
                                  ),
                                })
                              }
                              value={c.border?.left}
                              label="Left"
                              className="w-full"
                              font={{ size: 12 }}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                    <div className="flex-column mt-2" style={{ width: '80px' }}>
                      <Button size="small" label="Add" className="primary" onClick={() => addColumn()} />
                    </div>
                  </div>
                )}
                <div className="hr-line" />
                <GeneralConfig
                  component={component}
                  setSelectedComponent={updateComponentDetails}
                  panelWidgets={panelWidgets}
                  signers={signers}
                  colorPicker={colorPicker}
                  setColorPicker={setColorPicker}
                />
              </div>
            )}
            {component_type === 'CHOOSER' && (
              <Fragment>
                <div className="hr-line" />
                <ChooserOptionsConfig component={component} setSelectedComponent={updateComponentDetails} />
              </Fragment>
            )}
            {/* <div className="hr-line" /> */}
            <AdvancedConfig component={component} setSelectedComponent={updateComponentDetails} />
          </Fragment>
        )}
      </div>
    </ConfigWrapper>
  );
};

const ConfigWrapper = styled('div')`
  .input-element {
    height: 40px !important;
    border-radius: 16px;
  }
  .remove-color-btn {
    top: 13px;
    right: 10px;
  }
`;
